(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  // Cart drawer: opens on cart icon click and after add-to-cart.
  // Uses Shopify's Section Rendering API to refresh contents, so the
  // drawer HTML always comes from Liquid — no client-side templating.
  (() => {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    const sectionId = drawer.dataset.sectionId;

    const updateHeaderCount = () => {
      const header = drawer.querySelector('[data-drawer-count]');
      const count = header ? header.dataset.drawerCount : '0';
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        el.hidden = count === '0';
      });
    };

    const refresh = (sectionHtml) => {
      const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const fresh = parsed.querySelector('[data-drawer-panel]');
      const current = drawer.querySelector('[data-drawer-panel]');
      if (fresh && current) current.replaceWith(fresh);
      updateHeaderCount();
    };

    const fetchAndRefresh = () =>
      fetch(`${window.location.pathname}?sections=${sectionId}`)
        .then((r) => r.json())
        .then((data) => refresh(data[sectionId]));

    // Open from any element marked data-cart-toggle (the header icon)
    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-cart-toggle]');
      if (toggle) {
        e.preventDefault();
        drawer.showModal();
      }
      // Click on the backdrop (the dialog itself, outside the panel) closes
      if (e.target === drawer) drawer.close();
    });

    // Delegated clicks inside the drawer: close button, quantity changes
    drawer.addEventListener('click', (e) => {
      if (e.target.closest('[data-drawer-close]')) {
        drawer.close();
        return;
      }
      const qtyBtn = e.target.closest('[data-qty-change]');
      if (!qtyBtn) return;
      qtyBtn.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: Number(qtyBtn.dataset.line),
          quantity: Number(qtyBtn.dataset.qty),
          sections: sectionId,
        }),
      })
        .then((r) => r.json())
        .then((data) => refresh(data.sections[sectionId]))
        .catch(() => window.location.reload());
    });

    // Intercept add-to-cart forms site-wide, then open the drawer
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (!form.action || !form.action.includes('/cart/add')) return;
      e.preventDefault();
      const button = form.querySelector('button[type="submit"], input[type="submit"]');
      if (button) button.disabled = true;
      const formData = new FormData(form);
      formData.append('sections', sectionId);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then((r) => {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then((data) => {
          if (data.sections && data.sections[sectionId]) {
            refresh(data.sections[sectionId]);
            drawer.showModal();
          } else {
            return fetchAndRefresh().then(() => drawer.showModal());
          }
        })
        .catch(() => form.submit())
        .finally(() => {
          if (button) button.disabled = false;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Auto-submit the cart form when a quantity changes, so customers
  // don't need to click "Update cart" (the button still works without JS).
  document.querySelectorAll('[data-cart-form]').forEach((form) => {
    form.querySelectorAll('[data-cart-quantity]').forEach((input) => {
      input.addEventListener('change', () => form.submit());
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-order-form"] && !Shopify.designMode) return;
  try {
    
  // Custom order form: per-product colour options and the
  // date-needed minimum (in business days, skipping weekends).
  document.querySelectorAll('#custom-order-form').forEach((root) => {
    const optionsScript = document.querySelector('[data-order-options]');
    const productSelect = root.querySelector('[data-order-product]');
    const colourSelect = root.querySelector('[data-order-colour]');
    const colourWrapper = root.querySelector('[data-colour-wrapper]');
    const dateInput = root.querySelector('[data-order-date]');

    // Colour dropdown follows the selected product
    if (optionsScript && productSelect && colourSelect && colourWrapper) {
      const colourOptions = JSON.parse(optionsScript.textContent);

      const updateColours = () => {
        const colours = colourOptions[productSelect.value] || [];
        colourSelect.innerHTML = '';
        colours.forEach((colour) => {
          const option = document.createElement('option');
          option.value = colour;
          option.textContent = colour;
          colourSelect.appendChild(option);
        });
        if (colours.length) { const other = document.createElement('option'); other.value = colourSelect.dataset.otherLabel; other.textContent = colourSelect.dataset.otherLabel; colourSelect.append(other); }
        colourWrapper.hidden = colours.length === 0;
        colourSelect.required = colours.length > 0;
      };

      const referringHandle = new URLSearchParams(window.location.search).get('product');
      const referringOption = [...productSelect.options].find((option) => option.dataset.productHandle === referringHandle);
      if (referringOption) productSelect.value = referringOption.value;
      productSelect.addEventListener('change', updateColours);
      updateColours();
    }

    if (dateInput) {
      const date = new Date();
      dateInput.min = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.querySelectorAll('[data-site-header]').forEach((header) => {
  const disclosures = [...header.querySelectorAll('details')];
  disclosures.forEach((panel) => {
    panel.addEventListener('toggle', () => {
      panel.querySelector('summary').setAttribute('aria-expanded', String(panel.open));
      if (panel.open) { disclosures.forEach((other) => { if (other !== panel) other.open = false; }); if (panel.matches('[data-header-search]')) panel.querySelector('input[type="search"]').focus(); }
    });
    panel.addEventListener('keydown', (event) => { if (event.key === 'Escape') { event.preventDefault(); panel.open = false; panel.querySelector('summary').focus(); } });
  });
  document.addEventListener('click', (event) => { if (!header.contains(event.target)) disclosures.forEach((panel) => { panel.open = false; }); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popular-spotlight"] && !Shopify.designMode) return;
  try {
    
  // Per-product photo cross-fade, plus manual controls (dots + arrows)
  // so a visitor can cycle the images themselves. Auto-advance keeps
  // running but resets each time it is shown so a manual pick sticks.
  document.querySelectorAll('[data-spotlight]').forEach((stage) => {
    const imgs = [...stage.querySelectorAll('[data-spot-img]')];
    const dots = [...stage.querySelectorAll('[data-spot-dot]')];
    if (imgs.length < 2) return;

    const interval = parseInt(stage.dataset.interval, 10) || 4000;
    let i = 0;
    let timer = null;
    let onScreen = false;

    // Swap data-src in the first time a deferred photo is needed, so the page
    // only downloads the photos a visitor actually sees.
    const hydrate = (img) => {
      if (!img || !img.dataset.src) return;
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      delete img.dataset.src;
      delete img.dataset.srcset;
    };

    const swap = (n) => {
      imgs[i].classList.remove('is-active');
      if (dots[i]) dots[i].classList.remove('is-active');
      i = n;
      imgs[i].classList.add('is-active');
      if (dots[i]) dots[i].classList.add('is-active');
    };

    const show = (n) => {
      const target = (n + imgs.length) % imgs.length;
      const img = imgs[target];
      hydrate(img);
      // Warm the following photo so the next cross-fade is instant too
      hydrate(imgs[(target + 1) % imgs.length]);
      // Never fade to a photo that has not finished loading — on a slow
      // connection that left the frame blank. Hold the current photo and
      // swap the moment the new one is ready.
      if (img.complete && img.naturalWidth > 0) {
        swap(target);
      } else {
        img.addEventListener('load', () => swap(target), { once: true });
      }
    };

    const stop = () => {
      if (timer) clearInterval(timer);
      timer = null;
    };
    const start = () => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!onScreen) return;
      stop();
      // Warm the next photo now that this panel is on screen, so the first
      // cross-fade has something to fade to
      hydrate(imgs[(i + 1) % imgs.length]);
      timer = setInterval(() => show(i + 1), interval);
    };
    // A manual change: move, then restart the countdown from now
    const jump = (n) => {
      show(n);
      start();
    };

    dots.forEach((dot, n) => dot.addEventListener('click', () => jump(n)));
    const prev = stage.querySelector('[data-spot-prev]');
    const next = stage.querySelector('[data-spot-next]');
    if (prev) prev.addEventListener('click', () => jump(i - 1));
    if (next) next.addEventListener('click', () => jump(i + 1));

    // Pause while hovering so people can look; resume on leave
    stage.addEventListener('pointerenter', stop);
    stage.addEventListener('pointerleave', start);

    const io = new IntersectionObserver((entries) => {
      onScreen = entries[0].isIntersecting;
      onScreen ? start() : stop();
    }, { threshold: 0.2 });
    io.observe(stage);
  });

  // Rotate between the featured products (whole card) on a timer
  document.querySelectorAll('[data-spotlight-rotator]').forEach((rot) => {
    const panels = [...rot.querySelectorAll('[data-spot-panel]')];
    if (panels.length < 2) return;

    const interval = parseInt(rot.dataset.rotate, 10) || 300000; // default 5 min
    let idx = 0;

    setInterval(() => {
      panels[idx].classList.remove('is-active');
      idx = (idx + 1) % panels.length;
      panels[idx].classList.add('is-active');
    }, interval);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["print-reveal"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-print-video]').forEach((video) => {
    const toggle = video.closest('[data-print-section]').querySelector('[data-print-video-toggle]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const updateToggle = () => {
      if (!toggle) return;
      toggle.textContent = video.paused ? 'PLAY TIMELAPSE' : 'PAUSE TIMELAPSE';
      toggle.setAttribute('aria-pressed', video.paused ? 'true' : 'false');
    };

    if (reducedMotion) {
      video.pause();
      video.removeAttribute('autoplay');
      video.currentTime = 0;
    }

    if (toggle) {
      toggle.addEventListener('click', () => {
        if (video.paused) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
        updateToggle();
      });
    }

    video.addEventListener('play', updateToggle);
    video.addEventListener('pause', updateToggle);
    updateToggle();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Product page interactivity: thumbnail swapping and variant updates.
  // Deliberately small and dependency-free.
  document.querySelectorAll('[data-product]').forEach((root) => {
    root.dataset.enhanced = 'true';
    const thumbs = [...root.querySelectorAll('[data-thumb]')];
    const nativeVariant = root.querySelector('[data-native-variant]');
    const variantSelect = root.querySelector('[data-variant-select]');
    const variantChoices = [...root.querySelectorAll('[data-variant-choice]')];
    const optionChoices = [...root.querySelectorAll('[data-option-choice]')];
    const optionPickers = [...root.querySelectorAll('[data-option-picker]')];
    const variantLabel = root.querySelector('[data-variant-label]');
    const priceEl = root.querySelector('[data-price]');
    const skuEl = root.querySelector('[data-spec-sku]');
    const addButton = root.querySelector('[data-add-button]');
    if (nativeVariant) nativeVariant.hidden = true;
    if (variantSelect) variantSelect.tabIndex = -1;
    // Lets the colour selector jump the gallery to a variant's photo
    // once colour-specific images are assigned in the Shopify admin.
    let galleryGoToMedia = null;

    // Swipeable image carousel: native touch swipe + mouse drag, with
    // arrows, dots, and thumbnails all kept in sync with the position.
    const gallery = root.querySelector('[data-gallery]');
    if (gallery) {
      const track = gallery.querySelector('[data-slides]');
      const slides = [...gallery.querySelectorAll('[data-slide]')];
      const dots = [...gallery.querySelectorAll('.product__dot')];
      const prevBtn = gallery.querySelector('[data-gallery-prev]');
      const nextBtn = gallery.querySelector('[data-gallery-next]');

      const indexNow = () => Math.round(track.scrollLeft / track.clientWidth);
      const goTo = (i) => {
        const clamped = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: clamped * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      const setActive = (i) => {
        dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
        thumbs.forEach((t, n) => { t.classList.toggle('is-active', n === i); t.setAttribute('aria-pressed', String(n === i)); });
        const counter = root.querySelector('[data-gallery-count]');
        if (counter) counter.textContent = `${i + 1} / ${slides.length}`;
        slides.forEach((slide, n) => { if (n !== i) slide.querySelectorAll('video').forEach((video) => video.pause()); });
        const activeThumb = thumbs[i];
        if (activeThumb) { const tray = activeThumb.parentElement; if (activeThumb.offsetLeft < tray.scrollLeft || activeThumb.offsetLeft + activeThumb.offsetWidth > tray.scrollLeft + tray.clientWidth) tray.scrollTo({left: activeThumb.offsetLeft - tray.clientWidth / 2 + activeThumb.offsetWidth / 2, behavior: 'instant'}); }
        if (prevBtn) prevBtn.disabled = i <= 0;
        if (nextBtn) nextBtn.disabled = i >= slides.length - 1;
      };

      let raf;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => setActive(indexNow()));
      }, { passive: true });

      if (prevBtn) prevBtn.addEventListener('click', () => goTo(indexNow() - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => goTo(indexNow() + 1));
      thumbs.forEach((t, n) => t.addEventListener('click', () => goTo(n)));

      // Jump to the slide whose image matches a variant's assigned photo
      const defaultMediaId = slides[0] ? slides[0].dataset.mediaId : '';
      galleryGoToMedia = (mediaId) => {
        const targetMediaId = mediaId || defaultMediaId;
        const i = slides.findIndex((s) => s.dataset.mediaId === String(targetMediaId));
        if (i >= 0) goTo(i);
      };

      // Click and drag to swipe with a mouse (touch already scrolls)
      let dragging = false;
      let startX = 0;
      let startScroll = 0;
      track.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse' || e.target.closest('video,button,a')) return;
        dragging = true;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
      });
      track.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        track.scrollLeft = startScroll - (e.clientX - startX);
      });
      const endDrag = () => {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        goTo(indexNow());
      };
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointerleave', endDrag);

      // Left/right arrow keys move the carousel when it is in view
      gallery.addEventListener('keydown', (e) => {
        if (e.target.closest('video, input, select, textarea')) return;
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(indexNow() - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(indexNow() + 1); }
      });

      setActive(0);
    }

    // Colour swatches next to the 3D model. Tapping one drives the real
    // variant selector, so price, cart, the 3D colour, and the gallery
    // all update together — no scrolling up to the dropdown needed.
    const swatches = [...root.querySelectorAll('[data-3d-swatch]')];
    const colourLabel = root.querySelector('[data-3d-label]');

    const syncSwatches = () => {
      if (!variantSelect) return;
      const id = variantSelect.value;
      swatches.forEach((s) => s.setAttribute('aria-pressed', s.dataset.variantId === id ? 'true' : 'false'));
      const active = swatches.find((s) => s.dataset.variantId === id);
      if (colourLabel && active) colourLabel.textContent = active.dataset.colour.toUpperCase();
    };

    const syncVariantChoices = () => {
      if (!variantSelect) return;
      const id = variantSelect.value;
      variantChoices.forEach((choice) => {
        const selected = choice.dataset.variantId === id;
        choice.setAttribute('aria-checked', selected ? 'true' : 'false');
        choice.tabIndex = selected ? 0 : -1;
      });
      const active = variantChoices.find((choice) => choice.dataset.variantId === id);
      if (variantLabel && active) {
        variantLabel.textContent = active.querySelector('.product__variant-choice-label').textContent.trim();
      }
    };

    const parsedVariants = variantSelect
      ? [...variantSelect.options].map((option) => {
          let values = [];
          try {
            values = JSON.parse(option.dataset.options || '[]');
          } catch (error) {
            values = [];
          }
          return { option, values };
        })
      : [];

    const syncOptionChoices = () => {
      if (!variantSelect || optionChoices.length === 0) return;
      const selectedVariant = parsedVariants.find(({ option }) => option.value === variantSelect.value);
      if (!selectedVariant) return;

      optionChoices.forEach((choice) => {
        const position = Number(choice.dataset.optionPosition);
        const selected = selectedVariant.values[position] === choice.dataset.optionValue;
        choice.setAttribute('aria-checked', selected ? 'true' : 'false');
        choice.tabIndex = selected ? 0 : -1;

        const candidateValues = [...selectedVariant.values];
        candidateValues[position] = choice.dataset.optionValue;
        const available = parsedVariants.some(({ option, values }) =>
          !option.disabled && values.length === candidateValues.length &&
          values.every((value, index) => value === candidateValues[index])
        );
        choice.disabled = !available;
      });

      optionPickers.forEach((picker) => {
        const position = Number(picker.dataset.optionPosition);
        const label = picker.querySelector('[data-option-label]');
        if (label) label.textContent = selectedVariant.values[position] || '';
      });
    };

    variantChoices.forEach((choice, index) => {
      choice.addEventListener('click', () => {
        if (!variantSelect) return;
        variantSelect.value = choice.dataset.variantId;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      });
      choice.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
        event.preventDefault();
        const direction = event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 1;
        let nextIndex = index;
        do {
          nextIndex = (nextIndex + direction + variantChoices.length) % variantChoices.length;
        } while (variantChoices[nextIndex].disabled && nextIndex !== index);
        variantChoices[nextIndex].focus();
        variantChoices[nextIndex].click();
      });
    });

    optionPickers.forEach((picker) => {
      const choices = [...picker.querySelectorAll('[data-option-choice]')];
      choices.forEach((choice, index) => {
        choice.addEventListener('click', () => {
          if (!variantSelect) return;
          const currentVariant = parsedVariants.find(({ option }) => option.value === variantSelect.value);
          if (!currentVariant) return;
          const nextValues = [...currentVariant.values];
          nextValues[Number(choice.dataset.optionPosition)] = choice.dataset.optionValue;
          const nextVariant = parsedVariants.find(({ values }) =>
            values.length === nextValues.length && values.every((value, valueIndex) => value === nextValues[valueIndex])
          );
          if (!nextVariant) return;
          variantSelect.value = nextVariant.option.value;
          variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        });
        choice.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
          event.preventDefault();
          const direction = event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 1;
          let nextIndex = index;
          do {
            nextIndex = (nextIndex + direction + choices.length) % choices.length;
          } while (choices[nextIndex].disabled && nextIndex !== index);
          choices[nextIndex].focus();
          choices[nextIndex].click();
        });
      });
    });

    swatches.forEach((swatch) => {
      swatch.addEventListener('click', () => {
        if (!variantSelect) return;
        variantSelect.value = swatch.dataset.variantId;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // Changing the variant updates the price, add-to-cart state, the
    // active swatch, and (when set up) the gallery photo for that colour.
    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        const option = variantSelect.selectedOptions[0];
        if (priceEl && option.dataset.price) {
          priceEl.textContent = option.dataset.price;
          priceEl.classList.remove('glass-pop');
          void priceEl.offsetWidth;
          priceEl.classList.add('glass-pop');
        }
        if (addButton) {
          const soldOut = option.disabled;
          addButton.disabled = soldOut;
          addButton.textContent = soldOut ? 'Sold out' : 'Add to cart';
        }
        if (skuEl) skuEl.textContent = option.dataset.sku || '';
        syncVariantChoices();
        syncOptionChoices();
        syncSwatches();
        if (galleryGoToMedia) galleryGoToMedia(option.dataset.mediaId);
      });
    }
    syncVariantChoices();
    syncOptionChoices();
    syncSwatches();
    if (galleryGoToMedia && variantSelect) {
      galleryGoToMedia(variantSelect.selectedOptions[0].dataset.mediaId);
    }

    // 3D preview: recolour the model to match the selected variant.
    // Colours approximate the Bambu Lab PLA Matte palette (linear RGB),
    // and the material is set fully matte to look like a real print.
    const modelEl = root.querySelector('[data-product-model]');
    if (modelEl) {
      // Bambu Lab PLA Basic palette, converted from each filament's real
      // sRGB swatch to linear RGB (what glTF base-colour expects).
      const COLOURS = {
        white:  [0.913, 0.913, 0.896, 1],  // Jade White  #F5F5F3
        red:    [0.533, 0.027, 0.014, 1],  // Red         #C12E1F
        black:  [0.010, 0.010, 0.010, 1],  // Black       #1A1A1A
        blue:   [0.003, 0.022, 0.250, 1],  // Blue        #0A2989
        green:  [0.000, 0.423, 0.054, 1],  // Bambu Green #00AE42
        orange: [1.000, 0.144, 0.006, 1],  // Orange      #FF6A13
        pink:   [0.913, 0.089, 0.202, 1],  // Pink        #F5547C
        yellow: [0.905, 0.855, 0.023, 1],  // Yellow      #F4EE2A
        grey:   [0.271, 0.279, 0.250, 1],  // Gray        #8E9089
      };

      const currentColour = () => {
        const title = variantSelect
          ? variantSelect.selectedOptions[0].textContent.trim().split(' ')[0]
          : '';
        return COLOURS[title.toLowerCase()] || COLOURS.orange;
      };

      const applyColour = () => {
        const material = modelEl.model && modelEl.model.materials[0];
        if (!material) return;
        material.pbrMetallicRoughness.setBaseColorFactor(currentColour());
        material.pbrMetallicRoughness.setMetallicFactor(0);
        material.pbrMetallicRoughness.setRoughnessFactor(0.55);
      };

      modelEl.addEventListener('load', applyColour);
      if (variantSelect) variantSelect.addEventListener('change', applyColour);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  document.querySelectorAll('.search-page__form').forEach((form) => {
    const input = form.querySelector('input[type="search"]');
    if (!input) return;
    input.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      form.requestSubmit();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
